import type { PoolAlertDeviceType } from '../services/poolAlertDeviceService';

/** 경광등/부저 A — 게이트웨이 listen bind 샘플 */
export const ETH_RELAY_TCP_SERVER_A_SAMPLE_HOST = '0.0.0.0';

/** 경광등/부저 A — listen 포트 샘플 (테스트 스크립트와 동일) */
export const ETH_RELAY_TCP_SERVER_A_SAMPLE_PORT = 8800;

/** AliExpress TCP/IP 8채널 릴레이 출고 기본 IP. 현장에서 LAN에 맞게 수정. */
export const ETH_RELAY_TCP_HEX_SAMPLE_HOST = '192.168.1.200';

/** TCP Server로 바꾼 뒤 쓸 고정 포트 샘플. */
export const ETH_RELAY_TCP_HEX_SAMPLE_PORT = 5000;

export function ethRelayTcpHexCommands(channel: number): {
  start: string;
  stop: string;
} {
  const ch = Math.min(8, Math.max(1, Math.trunc(channel)));
  const on = (0xf0 + ch).toString(16);
  const off = ch.toString(16).padStart(2, '0');
  return {
    start: `hex:00 ${on} ff`,
    stop: `hex:00 ${off} ff`,
  };
}

/** 경광등 추가 시 Ch1, 부저 추가 시 Ch2 — 같은 박스에서 접점이 겹치지 않게. */
export function sampleAlertDeviceChannel(deviceType: PoolAlertDeviceType): number {
  return deviceType === 'buzzer' ? 2 : 1;
}

export function sampleAlertDeviceLabel(deviceType: PoolAlertDeviceType, channel: number): string {
  return deviceType === 'buzzer' ? `부저 Ch${channel}` : `경광등 Ch${channel}`;
}
